import { render, staticRenderFns } from "./AdminShippersTable.vue?vue&type=template&id=6cf18850"
import script from "./AdminShippersTable.vue?vue&type=script&lang=js"
export * from "./AdminShippersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-apistage/apistage.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cf18850')) {
      api.createRecord('6cf18850', component.options)
    } else {
      api.reload('6cf18850', component.options)
    }
    module.hot.accept("./AdminShippersTable.vue?vue&type=template&id=6cf18850", function () {
      api.rerender('6cf18850', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/AdminShippersTable.vue"
export default component.exports